import localStorageAdapter from './localstorage_adapter';
import LocationAdapter from './location_adapter';

export default class AhoyAdapter {
  static global(){
    if (!window.ahoy?.isReady){
      return this.tempAhoy()
    }
    // this.sendPendingEvent();
    return window.ahoy;
  }

  static noop(){
  }

  static tempAhoy(){
    if (this.shouldSavePendingEvent()) {
      return {
        track: this.setToLocalStorage
      }
    }

    return {
      track: this.noop
    }
  }

  static setToLocalStorage(name, properties){
    const data = JSON.parse(localStorageAdapter().getItem('tmp_ahoy_events')) || [];
    data.push([name, properties]);
    localStorageAdapter().setItem('tmp_ahoy_events', JSON.stringify(data));
  }


  static track(){
    this.global().track(...arguments);

    if (this.shouldLogEventOnConsole()) {
      this.logEventOnConsole(...arguments);
    }
  }

  static shouldLogEventOnConsole() {
    return LocationAdapter.search().ahoy_debug === '1';
  }

  static shouldSavePendingEvent() {
    return LocationAdapter.search().save_pending_events === 'true';
  }

  static logEventOnConsole(eventName, eventProperties) {
    window.console.warn(eventName, '+++', JSON.stringify(eventProperties));
  }
}
